import { AppMainComponent } from "src/app/app.main.component";
import { IMasterModel } from "./master.model";
import { DialogType } from "../constants/constants";
import { Attachment } from "./attachment.model";


export interface ICustomerRma extends IMasterModel {
    number: string,
    description: string,
    organizationId: number,
    channelId: number,
    accountId: number,
    warehouseId: number,
    orderLocationId: number,
    userId: number,
    totalAmount: number,
    netAmount: number,
    refundAmount: number,
    currencyUnitId: number,
    statusId: number,
    rmaStatusId: number,
    rmaStageId: number,
    rmaTypeId: number,
    exchangeRate: number,
    rmaReasonId: number,
    referenceNumber: string,
    invoiceOrderId: number,
    rmaDate: Date,
    configJSON: string,
    rmaAttachments: Attachment[],
    customerRMANotes: ICustomerRmaNote[],
    customerRMAProducts: CustomerRmaProduct[],
    customAttributeValues: any[],
    postingDate: string | Date;   
    postingMonth: number;
    postingYear: number;
}

export interface IVendorRma extends IMasterModel {
    number: string,
    description: string,
    organizationId: number,
    channelId: number,
    vendorId: number,
    warehouseId: number,
    orderLocationId: number,
    userId: number,
    totalAmount: number,
    netAmount: number,
    refundAmount: number,
    currencyUnitId: number,
    exchangeRate: number,
    statusId: number,
    rmaStatusId: number,
    rmaStageId: number,
    rmaTypeId: number,
    rmaReasonId: number,
    referenceNumber: string,
    billOrderId: number,
    rmaDate: Date,
    configJSON: string,
    vendorRMAAttachment: Attachment[],
    vendorRMANotes: ICustomerRmaNote[],
    vendorRMAProduct: VendorRmaProduct[],
    customAttributeValues: any[],
    postingDate: string | Date;   
    postingMonth: number;
    postingYear: number;
}

export class VendorRmaProduct implements IMasterModel {
    /**
     *
     */
    constructor(app: AppMainComponent, type, returnDetails) {
        this.createdSource = type == DialogType.EDIT ? returnDetails.createdSource : app.userIP;
        this.updatedSource = app.userIP;
        this.createdBy = type == DialogType.EDIT ? returnDetails.createdBy : app.user.userId;
        this.updatedBy = app.user.userId;
        this.createdDate = type == DialogType.EDIT ? returnDetails.createdDate : app._saveDateTimeWithZone(new Date());
        this.updatedDate = app._saveDateTimeWithZone(new Date());
    }

    id: number;
    createdSource: string;
    updatedSource: string;
    createdBy: number;
    updatedBy: number;
    createdDate: Date;
    updatedDate: Date;
    customerRMAId: number;
    description: string;
    productId: number;
    warrantyPeriod: Date;
    binId: number;
    warrantyTypeId: number;
    warranty: number;
    shippedQuantity: number;
    returnQuantity: number;
    approvedQuantity: number;
    productUOMId: number;
    pricePerProduct: number;
    totalAmount: number;
    billOrderId: number;
    statusId: number;
    vendorRMAProductSerialDetail: [];
}
export interface ICustomerRmaNote extends IMasterModel {

}

export class CustomerRmaProduct implements IMasterModel {
    /**
     *
     */
    constructor(app: AppMainComponent, type, returnDetails) {
        this.createdSource = type == DialogType.EDIT ? returnDetails.createdSource : app.userIP;
        this.updatedSource = app.userIP;
        this.createdBy = type == DialogType.EDIT ? returnDetails.createdBy : app.user.userId;
        this.updatedBy = app.user.userId;
        this.createdDate = type == DialogType.EDIT ? returnDetails.createdDate : app._saveDateTimeWithZone(new Date());
        this.updatedDate = app._saveDateTimeWithZone(new Date());
    }

    id: number;
    createdSource: string;
    updatedSource: string;
    createdBy: number;
    updatedBy: number;
    createdDate: Date;
    updatedDate: Date;
    customerRMAId: number;
    description: string;
    productId: number;
    warrantyPeriod: Date;
    binId: number;
    warrantyTypeId: number;
    warranty: number;
    shippedQuantity: number;
    returnQuantity: number;
    approvedQuantity: number;
    productUOMId: number;
    pricePerProduct: number;
    totalAmount: number;
    invoiceId: number;
    statusId: number;
    rmaProductSerialDetails: [];
    rMABundleDetails: BundleItems[];
}

export interface BundleItems {
    id: number;
    createdSource: string;
    updatedSource: string;
    createdBy: number;
    updatedBy: number;
    createdDate: string;
    updatedDate: string;
    customerRMAId: number;
    description: string;
    productId: number;
    rmaProductId: number;
    subProductId: number;
    parentProductId: number;
    parentBundleId: number;
    availableQty: number;
    actualPrice: number;
    quantity: number;
    pricePerProduct: number;
    productUOMId: number;
    statusId: number;
    discountId: number;
    totalQty: number;
    totalAmount: number;
    invoiceId: number;
    approvedQuantity: number;
    warrantyPeriod: Date;
    binId: number;
    warrantyTypeId: number;
    warranty: number;
    shippedQuantity: number;
    returnQuantity: number;
    rmaBundleProductSerialDetail:[];
}

export interface ICustomAtributes {
    billing_address_item: any[]; 
    shipping_address_item: any[];
    misc_item: any[];
    message_item: any[];
    other1_item: any[];
    other2_item: any[];
    other3_item: any[];
}